/* istanbul ignore file */

import { getPadraoComRetorno, postPadraoComRetorno, putPadraoComRetorno, deletePadrao } from 'services/api';
import { montarUrlFiltro, compararPerfis } from 'utils/funcaoPadrao';
import { getUser } from 'services/auth';
import { duckTodosAtendentes, duckAtendenteDetalhar, duckAtendenteLogado } from 'store/ducks/atendente';
import { duckInputSelectOptionsAtendentes } from 'store/ducks/inputs';
import { fetchNotificationApp, fetchStatusModalAcessoNegado } from 'store/fetchActions/fetchApp';
import { visualizarAtendente, listarAtendente } from 'routes/paths';
import {
  ALERTA,
  MSG_ATENDENTE_DELETADO_SUCESSO,
  ENUM_MODAL,
  USUARIO_LOGADO_FAS,
  ENUM_STATUS_ATIVO,
  ENUM_CONDICAO_STATUS,
} from 'utils/consts';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';

export const fetchSalvarAtendente = atendente => dispatch => {
  return new Promise((resolve, reject) => {
    const url = 'Atendente/InserirAtendente';
    dispatch(postPadraoComRetorno(url, atendente))
      .then(res => resolve(res))
      .catch(erro => reject(erro));
  });
};

export const fetchGetTodosAtendentes = () => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(getPadraoComRetorno('Atendente'))
      .then(res => resolve(res))
      .catch(erro => reject(erro));
  });
};

export const fetchGetAtendentesPorSetor = filtros => dispatch => {
  const url = `Atendente/ObterAtendente${filtros}`;
  return new Promise((resolve, reject) => {
    dispatch(getPadraoComRetorno(url))
      .then(res => resolve(res))
      .catch(erro => reject(erro));
  });
};

export const fetchGetTodosAtendentesGeral = () => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(getPadraoComRetorno('Atendente/ObterTodasAsAtendente'))
      .then(res => {
        dispatch(duckInputSelectOptionsAtendentes(res));
        resolve(res);
      })
      .catch(erro => reject(erro));
  });
};

export const fetchIniciarAtendimento = atendenteId => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(postPadraoComRetorno(`Formulario/StartService?atendenteId=${atendenteId}`))
      .then(res => resolve(res))
      .catch(erro => reject(erro));
  });
};

export const fetchGetAtendenteByDocumento = (cpfCnpjAtendente, atendenteLogado) => dispatch => {
  return new Promise((resolve, reject) => {
    if (atendenteLogado) resolve(atendenteLogado);
    else {
      const user = getUser();
      const documento = cpfCnpjAtendente ? cpfCnpjAtendente : user?.cpf_cnpj;
      if (!documento) {
        reject(documento);
        return;
      }
      if (user?.profile === ENUM_TIPO_PERFIL.CONTRIBUINTE) {
        reject(user?.profile);
        return;
      }

      dispatch(fetchGetAtendente(documento)).then(res => resolve(res));
    }
  });
};

export const fetchGetAtendente = (documento, user) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(getPadraoComRetorno(`Atendente/documento=${documento}`))
      .then(res => {
        if (res?.id === 0) {
          dispatch(
            fetchStatusModalAcessoNegado(true, ENUM_MODAL.PERFIL_SEM_CADASTRO_NO_FAS, {
              idAtendente: res?.id,
            })
          );
          reject(res);
        } else if (
          res?.situacaoId === ENUM_STATUS_ATIVO.INATIVO.value ||
          res.condicaoId !== ENUM_CONDICAO_STATUS.APROVADO.id
        ) {
          dispatch(
            fetchStatusModalAcessoNegado(true, ENUM_MODAL.CADASTRO_PENDENTE, {
              situacaoId: res?.situacaoId,
            })
          );
          reject(res);
        } else if (!compararPerfis(res, user)) {
          dispatch(
            fetchStatusModalAcessoNegado(true, ENUM_MODAL.PERFIL_DIVERGENTE, {
              situacaoId: res?.situacaoId,
            })
          );
          reject(res);
        } else {
          sessionStorage.setItem(USUARIO_LOGADO_FAS, JSON.stringify(res));
          dispatch(fetchAtendenteLogado(res));
          resolve(res);
        }
      })
      .catch(erro => reject(erro));
  });
};

export const fetchGetAtendenteById = (idAtendente, history, isSalvar = true) => dispatch => {
  return new Promise(resolve => {
    dispatch(getPadraoComRetorno(`Atendente/${idAtendente}`)).then(res => {
      if (!isSalvar) resolve(res);
      else {
        dispatch(duckAtendenteDetalhar(res));
        if (history) {
          history.push(visualizarAtendente);
        }
      }
    });
  });
};

export const fetchGetAtendentesLista = (page, itemsByPage, filtro) => dispatch => {
  return new Promise((resolve, reject) => {
    const url = montarUrlFiltro(`Atendente/page=${page}&itemsByPage=${itemsByPage}`, filtro);
    dispatch(duckTodosAtendentes({ list: [] }));
    dispatch(getPadraoComRetorno(url, true, true))
      .then(res => {
        dispatch(duckTodosAtendentes(res));
        resolve(res);
      })
      .catch(erro => reject(erro));
  });
};

export const fetchAtualizarAtendente = dadosAtendente => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(putPadraoComRetorno('Atendente', dadosAtendente))
      .then(res => resolve(res))
      .catch(erro => reject(erro));
  });
};

export const fetchDeletarAtendente = (idAtendente, history) => dispatch => {
  const success = () => {
    fetchNotificationApp(MSG_ATENDENTE_DELETADO_SUCESSO, '', ALERTA.SUCESSO);
    history.push(listarAtendente);
  };
  dispatch(deletePadrao(`Atendente/${idAtendente}`, success));
};

export const fetchAtendenteLogado = atendente => dispatch => {
  dispatch(duckAtendenteLogado(atendente));
};
